export const UPING = 0
export const UPERR = 1
export const UPSUCCESS = 2
export const UPREADY = 3